import React from 'react';
import HeroBG from '../assets/img/headbg.jpeg';
import Typed from 'typed.js';

const Home = () => {

    React.useEffect(() => {
        const preloader = document.querySelector("#preloader");

        if (preloader) {
            window.addEventListener('load', () => {
                preloader.remove();
            })
        }

        /**
        * Init typed.js
        */
        const selectedTyped = document.querySelector('.typed');
        if (selectedTyped) {
            let typed_strings = selectedTyped.getAttribute('data-typed-items');
            typed_strings = typed_strings.split(',');
            const type = new Typed('.typed', {
                strings: typed_strings,
                loop: true,
                typeSpeed: 100,
                backSpeed: 50,
                backDelay: 2000
            })

            return () => {
                type.destroy();
            }
        }

    }, [])

   

    return (
        <>
            {/* Home Section */}
            <section id="home" className="hero section dark-background">
                <img src={HeroBG} alt="" data-aos="fade-in" className="" />
                <div className="container" data-aos="fade-up" data-aos-delay={100}>
                    <h2>Hai, Saya Fajar Subhan</h2>
                    <p>
                        Saya Seorang{" "}
                        <span
                            className="typed"
                            data-typed-items="Software Developer, Freelancer, Web Developer, Staff IT , IT Support"
                        >
                            Software Developer
                        </span>
                        <span className="typed-cursor typed-cursor--blink" aria-hidden="true"></span>
                    </p>
                </div>

            </section>
            {/* /Home Section */}
        </>
    )
}

export default Home;